import { Link } from "react-router-dom";
import { hotTopics } from "@/mocks/topics";

const timeLabels = ["09:20", "08:45", "07:30", "昨晚 23:10", "昨晚 21:40"];

export default function TodaySection() {
  const feed = hotTopics.slice(0, 5);
  const rankList = [...hotTopics].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const tags = hotTopics.slice(0, 8).flatMap((t) => t.tags).slice(0, 12);

  return (
    <section id="today" className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="font-label text-xs font-bold tracking-[0.25em] text-primary-600">
            TODAY FEED
          </span>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            今日速递
          </h2>
        </div>
        <Link
          to="/rank"
          className="flex items-center gap-1 whitespace-nowrap font-label text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          查看完整榜单
          <i className="ri-arrow-right-line h-4 w-4 flex items-center justify-center"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <ol className="flex flex-col">
            {feed.map((topic, index) => (
              <li key={topic.id} className="relative flex gap-4 pb-7 last:pb-0">
                <div className="flex flex-col items-center">
                  <span className="flex h-2.5 w-2.5 shrink-0 rounded-full bg-primary-500"></span>
                  {index !== feed.length - 1 ? (
                    <span className="mt-1 w-px flex-1 bg-background-300"></span>
                  ) : null}
                </div>
                <div className="flex-1">
                  <span className="font-label text-xs font-medium text-foreground-500">
                    {timeLabels[index]}
                  </span>
                  <Link to={`/topic/${topic.id}`} className="mt-1 block">
                    <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors hover:text-primary-600">
                      {topic.title}
                    </h3>
                  </Link>
                  <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {topic.summary}
                  </p>
                  <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1 font-medium text-primary-600">
                      <i className="ri-fire-line h-4 w-4 flex items-center justify-center"></i>
                      热度 {topic.heat}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line h-4 w-4 flex items-center justify-center"></i>
                      {topic.comments} 讨论
                    </span>
                    <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-secondary-800">
                      {topic.category}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <aside className="flex flex-col gap-6">
          <div className="rounded-lg border border-background-200 bg-background-100 p-5">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-fire-fill h-5 w-5 flex items-center justify-center text-primary-500"></i>
              实时热议前五
            </h3>
            <ul className="mt-4 flex flex-col">
              {rankList.map((topic, index) => (
                <li key={topic.id}>
                  <Link
                    to={`/topic/${topic.id}`}
                    className="flex items-start gap-3 border-b border-background-200 py-2.5 last:border-b-0"
                  >
                    <span
                      className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded font-label text-xs font-bold ${
                        index < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-300 text-foreground-700"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors hover:text-primary-600">
                      {topic.title}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5">
            <h3 className="font-heading text-lg font-bold text-foreground-950">热议标签</h3>
            <div className="mt-3 flex flex-wrap gap-2">
              {tags.map((tag) => (
                <Link
                  key={tag}
                  to={`/rank?q=${encodeURIComponent(tag)}`}
                  className="whitespace-nowrap rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 font-label text-xs text-secondary-800 transition-colors hover:bg-secondary-100"
                >
                  #{tag}
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}